import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddToTalentpoolComponent } from 'src/app/talentpool/add-to-talentpool/add-to-talentpool.component';

@Component({
    selector: 'app-taggedto-tab',
    templateUrl: './taggedto-tab.component.html',
    styleUrls: ['./taggedto-tab.component.scss'],
    standalone: false
})
export class TaggedtoTabComponent implements OnInit {

  @Input() candidatedata;
  successMessage: string = ''
  errorMessage: string =''
  @Output() passEntryEvent: EventEmitter<any> = new EventEmitter();
  @Output() openModalEvent = new EventEmitter<void>();
  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  addtoTalentpool() {
    const modalRef = this.modalService.open(AddToTalentpoolComponent, { size: 'lg' as 'lg', centered: true });
    modalRef.componentInstance.candidatetoAdd = this.candidatedata.basicdetails[0]
    modalRef.componentInstance.BuldCandidatetoAdd =[]
    modalRef.componentInstance.type = 'candidate'
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'candidateAdded') {
        this.toastmessage('Candidate Added to Talentpool Succesfully', 'success')
        this.passEntryEvent.emit('added')
      } else if (x == 'alreadyexist') {
        this.toastmessage('Candidate has already been added to this talentpool', 'success')
      } else if (x == 'error') {
        this.toastmessage('Something went Wrong', 'error')
        this.passEntryEvent.emit('error')
      }
    })
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }
  //Add candidate to email campaign
  open() {
      this.openModalEvent.emit();
  }
}
